import { render, staticRenderFns } from "./UnloadingBaseClassList.vue?vue&type=template&id=68b3ac58&lang=pug"
import script from "./UnloadingBaseClassList.vue?vue&type=script&lang=js"
export * from "./UnloadingBaseClassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports